import { GenericHeader, SearchBar } from 'components';
import { makeStyles } from '@material-ui/core/styles';
import ListComp from 'components/ListComp';
import React from 'react';
import { ItemClass } from 'services';
import { Results, CreateModal } from './components';
import { ecommerce_manager } from 'utils/constants';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  button: {
    "&:not(:last-child)": {
      marginRight: theme.spacing(2)
    }
  }
}));

const ItemClassList = props => {
  const classes = useStyles();

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Item Classes" subheader="Item Class Management" {...rest} >
        <Button className={classes.button} color="primary" onClick={handleCreateOpen} variant="contained">
          Add Item Class
        </Button>
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={ItemClass.list}
      title="Item Classes"
      name="item_classes"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      roles={[ecommerce_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default ItemClassList;
